import LayoutPage from "../../Components/LayoutPage"
import NavLayer2 from "../../Components/NavLayer2/NavLayer2"
import KYCCard from "./Components/KYCCard"

export default function KYC() {
  return (
    <LayoutPage activeIndex={12} navItems={["حساب کاربری"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5">
      <NavLayer2 texts={["اطلاعات حساب" , "امنیت حساب", "احراز هویت"]} hrefs={["/profile/information" , "/profile/security", "/profile/kyc"]} activeIndex={2}/>
      <div className="w-full h-fit flex flex-col items-center gap-5 min-h-0 overflow-y-auto">
        <KYCCard/>
      </div>
    </LayoutPage>
  )
}